//Choose location to put item, move item, or split and move
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Typography } from "@mui/material";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
} from "../../../../ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

//Actions
import { changeAddModalView, setCreateLocation } from "../../../../../actions/pantry";

export const ChooseLocation = ({ pantry: { locations, create }, changeAddModalView, setCreateLocation }) => {
  const [locationId, setLocationId] = useState(create?.data?.location || null);

  // Group locations by type for sectioned dropdown
  const groupedLocations = locations.data.reduce((acc, loc) => {
    const type = loc.type || "Other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(loc);
    return acc;
  }, {});

  const handleLocationSelect = (id) => {
    setLocationId(id);
    setCreateLocation(id);
  };

  const handleNext = () => {
    //TODO: Handle setting location
    changeAddModalView({ stage: "ingredients" });
  };

  const handleBack = () => {
    //TODO: Handle back
    changeAddModalView({ stage: "location", type: "initial" });
  };

  return (
    <div className="w-full">
      <div className="p-4 bg-neutral-100">
        <Typography variant="h6" className="font-normal">
          Select Location
        </Typography>
      </div>
      <div className="p-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outlined"
              className="w-full justify-between font-normal rounded-lg border-secondaryText-200 hover:border-primaryText font-sans text-md"
            >
              {locationId
                ? locations.data.find((loc) => loc._id === locationId)?.name || "Choose a location..."
                : "Choose a location..."}
              <ChevronDown className="w-3 opacity-50 ml-2" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[var(--radix-dropdown-menu-trigger-width)] rounded-[8px] z-[1301]">
            {Object.entries(groupedLocations).map(([section, locs]) => (
              <React.Fragment key={section}>
                <DropdownMenuLabel>{section}</DropdownMenuLabel>
                {locs.map((loc) => (
                  <DropdownMenuItem
                    key={loc._id}
                    onSelect={() => handleLocationSelect(loc._id)}
                    className={`${locationId === loc._id ? "font-medium text-mainGreen" : "text-secondaryText-600/90"}`}
                  >
                    {loc.name}
                  </DropdownMenuItem>
                ))}
              </React.Fragment>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <div className="flex justify-between mt-6 gap-2">
          <Button
            variant="contained"
            color="secondary"
            className="text-primaryText"
            disableRipple
            disableElevation
            onClick={handleBack}
          >
            Back
          </Button>
          <div className="flex items-center">
            <Button
              variant="contained"
              color="primary"
              disabled={!locationId}
              onClick={handleNext}
              disableRipple
              disableElevation
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

ChooseLocation.propTypes = {
  pantry: PropTypes.object.isRequired,
  changeAddModalView: PropTypes.func.isRequired,
  setCreateLocation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps, { changeAddModalView, setCreateLocation })(ChooseLocation);
